import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ title, description, keywords, canonical, type = 'website', image }) => {
  const defaultImage = `${process.env.PUBLIC_URL}/og-image.png`;
  const metaImage = image || defaultImage;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="Barry Howell for Marshall County Jailer" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={metaImage} />
      
      {/* Geo-tagging for Local SEO */}
      <meta name="geo.region" content="US-KY" />
      <meta name="geo.placename" content="Marshall County" />
      <meta name="geo.position" content="36.8837;-88.3364" /> {/* Coordinates for Benton, KY (Marshall County seat) */}
      <meta name="ICBM" content="36.8837, -88.3364" />
    </Helmet>
  );
};
